export default function ChoiceChecklist(props) {
    return(
        <div className="input-group">
            <span className="input-group-text text-primary">
                {props.label}
            </span>
            <select
                className="form-control"
                value={props.value}
                required={props.required}
                disabled={true}
            >
                    {props.options && props.options.map((item, index) => (
                        <option key={index} value={item}>
                            {item}
                        </option>
                    ))}
            </select>
        </div>
    )
}